// Файл Button.js

/**
 * Универсальная кнопка приложения нормализует размеры,
 * варианты оформления и доступные состояния управления.
 */

import { useAccess } from '../../services/AccessContext';
import LoadingIndicator from '../../shared_code/loading';

import './Button.css';



const action_variants = {
    add: 'primary',
    save: 'primary',
    delete: 'danger',
    cancel: 'danger',
    download: 'primary',
};

const action_icons = {
    delete: '🗑',
    download: '↓',
};


const normalize_width = (width) => {
    if (width === undefined || width === null || width === 'auto') {
        return null;
    }

    if (typeof width === 'number') {
        return `${width}px`;
    }

    return String(width);
};


const Button = ({
    text,
    children,
    clickAction,
    variant,
    action_type = '',
    size = 'medium',
    disabled = false,
    loading = false,
    className = '',
    type = 'button',
    width = 'auto',
    fullWidth = false,
    stretch = false,
    wrap = false,
    square = false,
    active = false,
    title,
    ariaLabel,
    id,
    style,
    ...var_4
}) => {
    const { hasAccess } = useAccess();
    const resolved_width = normalize_width(width);
    const normalized_text = String(text || '');
    const inferred_action_type = action_type || (
        /^Скачать(?:\s|$)/iu.test(normalized_text)
            ? 'download'
            : ''
    );
    const resolved_variant = (
        variant
        || action_variants[inferred_action_type]
        || 'primary'
    );
    const action_icon = action_icons[inferred_action_type] || '';
    const download_denied = (
        inferred_action_type === 'download'
        && !hasAccess('4.5')
    );
    const access_title = download_denied
        ? 'Недостаточно прав: требуется доступ 4.5 — скачивание данных'
        : title;

    const button_style = resolved_width
        ? {
            ...style,
            width: resolved_width,
        }
        : style;
    const var_3 = [
        'btn',
        `btn-${resolved_variant}`,
        `btn-${size}`,
        (fullWidth || stretch) ? 'full-width' : '',
        wrap ? 'btn-wrap' : '',
        square ? 'btn-square' : '',
        active ? 'btn-active' : '',
        (disabled || download_denied) ? 'disabled' : '',
        className,
    ].filter(Boolean).join(' ');

    const button = (
        <button
            type={type}
            className={var_3}
            onClick={clickAction}
            disabled={disabled || loading || download_denied}
            title={access_title}
            aria-label={ariaLabel || access_title || text}
            id={id}
            style={button_style}
            {...var_4}
        >
            {action_icon && (
                <span className="btn__action-icon" aria-hidden="true">
                    {action_icon}
                </span>
            )}
            {loading ? (
                <LoadingIndicator size="small" />
            ) : (children ?? text)}
        </button>
    );

    if (download_denied) {
        return (
            <span
                className={
                    'btn-access-tooltip'
                    + ((fullWidth || stretch) ? ' full-width' : '')
                }
                title={access_title}
            >
                {button}
            </span>
        );
    }

    return button;
};


export default Button;
